<style lang="scss">
.cm-dialog {
    display: block;

    .cm-dialog-content {
        padding: 5px 10px;
    }
}

.cm-dialog-disable {
    display: block;

    .van-dialog__footer {
        background-color: #ccc;

        color: #ccc;

        * {
            color: #ccc;
        }
    }
}
</style>
<template>
    <van-dialog ref="cmDialog" :className="!can_close ? 'cm-dialog cm-dialog-disable' : 'cm-dialog'" v-model="show"
                @cancel="cancel" @confirm="confirm" @open="onopen" @opened="opened" @close="close" title="标题"
                :show-confirm-button="showConfirmButton" :show-cancel-button="showCancelButton"
                :confirm-button-text="confirmButtonText" :before-close="beforeClose"
                :cancel-button-text="cancelButtonText" :title="title" :lock-scroll="lockScroll">
        <slot name="default">
            <div v-html="content" class="cm-dialog-content">

            </div>
        </slot>
    </van-dialog>
</template>
<script>
export default {
    name: 'cm-alert',
    description: '自定义弹窗 支持强制阅读倒计时',
    components: {

    },
    model: {
        // 需要双向绑定的 props 变量名称，也就是父组件通过 v-model 与子组件双向绑定的变量
        prop: 'value',
        // 定义由 $emit 传递变量的名称
        event: 'newValue'
    },
    data() {
        return {
            step: 0,
            show: false,
            tabList: [],
            index: this.value,
            valueName: '请选择',
            init: 0,
            myInterval: null,
            myInterval2: null,
            can_close: true,
            // 剩余毫秒
            notime: 0,
            // 剩余秒数
            notimeSec: 0,
        };
    },
    props: {
        duration: {
            type: Number,
            default: 0
        },
        title: {
            type: String,
            default: '提示信息'
        },
        content: {
            type: String,
            default: ''
        },
        showConfirmButton: {
            type: Boolean,
            default: true
        },
        showCancelButton: {
            type: Boolean,
            default: false
        },
        confirmButtonText: {
            type: String,
            default: '确定'
        },
        cancelButtonText: {
            type: String,
            default: '取消'
        },
        lockScroll: {
            type: Boolean,
            default: true
        },
    },
    watch: {
        value: {
            handler(v) {
                if (this.init < 2) {
                    setTimeout(() => {
                        this.index = v
                        this.init++
                    }, 100)
                }
            },
            immediate: true,
        }
    },
    mounted() {

    },
    destroyed() {
        clearInterval(this.myInterval);
        this.myInterval = null
        clearInterval(this.myInterval2);
        this.myInterval2 = null
    },
    methods: {
        open() {
            console.log('KAIS1',);
            this.show = true;
        },
        startTimeOnClose() {
            if (!isNaN(this.duration) && this.duration > 0) {
                this.can_close = false;
                this.notime = this.duration;
                this.myInterval = setInterval(this.showCloseBtn, parseInt(this.duration));
                this.updateBtnBody(this.notime = this.notime + 1000);
                this.myInterval2 = setInterval(this.updateBtnBody, 1000);
            }
        },
        updateBtnBody() {
            this.notime -= 1000;
            this.notimeSec = Math.ceil(this.notime / 1000);
            this.$nextTick(() => {
                if (this.$refs.cmDialog) {
                    // 查找取消按钮
                    var el = this.$refs.cmDialog.$el.querySelector('.van-dialog__cancel')
                    if (!el) {
                        // 找不到就查找确定按钮
                        el = this.$refs.cmDialog.$el.querySelector('.van-dialog__confirm')
                    }

                    if (el) {
                        if (this.notime <= 0) {
                            el.querySelector('.van-button__text').innerHTML = this.confirmButtonText || '确定';
                            clearInterval(this.myInterval2);
                            return;
                        }
                        else {
                            el.querySelector('.van-button__text').innerHTML = this.notimeSec + '秒后可关闭';
                        }
                    }
                }

                else {
                    console.log('this.$refs.cmDialog', this.$refs);
                }
            })
        },
        showCloseBtn() {
            this.can_close = true;
        },
        close() {
            this.show = false
        },
        cancel() {
            if (this.can_close) {
                this.show = false;
                this.$emit('cancel');
            }
        },
        confirm() {
            if (this.can_close) {
                this.show = false;
                this.$emit('confirm');
            }
        },
        onopen() {
            this.$emit('open');
        },
        close() {
            this.$emit('close');
        },
        opened() {
            this.startTimeOnClose();
        },
        beforeClose(action, done) {
            if (action) {
                if (this.can_close) {
                    done();
                }
                else {
                    done(false);
                }
            }
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/CmAlert/index.vue